/* ==========================================================================
   PWR COMPARISON
   ----------------------------------------------------------------------------
   The ONE behaviour the engine does not fully own: animating the comparison
   BAR FILLS from 0 to their value when the section scrolls into view.

   Why this isn't a duplicate: the Animation Engine's count-up animates a
   meter's NUMBER text ([data-pwr-countup]) but does not drive the fill
   width. Here the bars must visibly fill on reveal, so this controller sets
   each fill to 0, then to its target --pwr-meter-val when in view. The number
   count-up stays engine-owned ([data-pwr-countup]); we only touch the fill.

   Reused, NOT reimplemented:
     - Number count-up   -> engine [data-pwr-countup]
     - Fade / cascade    -> engine [data-pwr-reveal] / -group
     - Meter markup/CSS  -> .pwr-meter* (Design System) via the section
     - Lifecycle / utils -> JS Core (registerSection, utils)

   Registered via PWR.registerSection => Theme Editor safe, no double init.
   Transform/opacity/width only. Reduced motion => bars jump straight to value.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.PWR || !window.PWR.registerSection) return;
  var PWR = window.PWR;
  var utils = PWR.utils;
  var Section = PWR.Section;

  function Comparison(root) {
    Section.call(this, root);
  }
  Comparison.prototype = Object.create(Section.prototype);
  Comparison.prototype.constructor = Comparison;

  Comparison.prototype.init = function () {
    this.fills = this.$$('[data-pwr-bar]');
    if (!this.fills.length) return;

    // Reduced motion or no observer: show final values immediately.
    if (utils.prefersReducedMotion() || !('IntersectionObserver' in window)) {
      this._settleAll();
      return;
    }

    // Start collapsed, then fill when the section scrolls into view.
    this._collapseAll();

    var self = this;
    this._io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        self._fill(entry.target);
        self._io.unobserve(entry.target);
      });
    }, { threshold: 0.35 });

    this.fills.forEach(function (el) { self._io.observe(el); });
    this.addCleanup(function () { if (self._io) self._io.disconnect(); });
  };

  Comparison.prototype._target = function (el) {
    return parseFloat(el.getAttribute('data-pwr-bar')) || 0;
  };

  Comparison.prototype._collapseAll = function () {
    for (var i = 0; i < this.fills.length; i++) {
      this.fills[i].style.setProperty('--pwr-meter-val', '0%');
    }
  };

  Comparison.prototype._settleAll = function () {
    for (var i = 0; i < this.fills.length; i++) {
      this.fills[i].style.setProperty('--pwr-meter-val', this._target(this.fills[i]) + '%');
    }
  };

  Comparison.prototype._fill = function (el) {
    // Next frame so the 0% starting value is committed before transitioning.
    var self = this;
    window.requestAnimationFrame(function () {
      el.style.setProperty('--pwr-meter-val', self._target(el) + '%');
    });
  };

  PWR.registerSection('pwr-comparison', function (root) { return new Comparison(root); });
})();
